import { ProductFlow, StockVariationType } from 'data/__generated__';

export const siteVariationsColors: Record<StockVariationType, string> = {
    [StockVariationType.Donated]: '#05fdc3',
    [StockVariationType.KnownLossesBroken]: '#FD6205',
    [StockVariationType.KnownLossesDlc]: '#FD6205',
    [StockVariationType.Transaction]: '#00ED76',
    [StockVariationType.TrayReassort]: '#00AAAA',
    [StockVariationType.KnownSales]: '#00ED76',
    [StockVariationType.MicrostoreReassort]: '#FF4444',
    [StockVariationType.MicrostoreWarehouseReturn]: '#FD6205',
    [StockVariationType.NotDelivered]: '#e805fd',
    [StockVariationType.NotPrepared]: '#e805fd',
    [StockVariationType.Reappearing]: '#FD6205',
    [StockVariationType.Refund]: '#5C7CFB',
    [StockVariationType.PreparedProductReset]: '#CCCC00',
    [StockVariationType.StockTransfert]: '#ABCABC',
    [StockVariationType.SupplierRefund]: '#5C7CFB',
    [StockVariationType.UnknownLosses]: '#FF11A8',
    [StockVariationType.UnknownLossesSolved]: '#FF11A8',
    [StockVariationType.UnknownSales]: '#990000',
    [StockVariationType.UnknownSalesSolved]: '#990000',
    [StockVariationType.WarehouseAdditionalDeliveryInRack]: '#FF4444',
    [StockVariationType.WarehouseInBox]: '#00AAAA',
    [StockVariationType.WarehouseInRack]: '#FF4444',
    [StockVariationType.WarehouseBundleAborted]: '#CCCC00',
    [StockVariationType.Prepared]: '#0f23d6',
};

export const siteVariationsLabels: Record<StockVariationType, string> = {
    [StockVariationType.Donated]: 'Produit(s) donné(s)',
    [StockVariationType.KnownLossesBroken]: 'Produit(s) cassé(s)',
    [StockVariationType.KnownLossesDlc]: 'DLC dépassé(s)',
    [StockVariationType.Transaction]: 'Transaction',
    [StockVariationType.TrayReassort]: 'Réassort bac machine à café',
    [StockVariationType.KnownSales]: 'Vente(s) connue(s)',
    [StockVariationType.MicrostoreReassort]: 'Réassortissement du microstore',
    [StockVariationType.MicrostoreWarehouseReturn]: 'Retour entrepôt',
    [StockVariationType.NotDelivered]: 'Non délivré (erreur de prep)',
    [StockVariationType.NotPrepared]: 'Non préparé (erreur de prep)',
    [StockVariationType.PreparedProductReset]: 'Annulation de produit preparé',
    [StockVariationType.Reappearing]: 'Produit(s) retrouvé(s)',
    [StockVariationType.Refund]: 'Remboursement',
    [StockVariationType.StockTransfert]: 'Transfert de stock',
    [StockVariationType.SupplierRefund]: 'Remboursement fournisseur',
    [StockVariationType.UnknownLosses]: 'Démarque(s) inconnue(s)',
    [StockVariationType.UnknownLossesSolved]: 'Problème de démarques(s) inconnue(s) résolue',
    [StockVariationType.UnknownSalesSolved]: 'Problème de surmarques(s) inconnue(s) résolue',
    [StockVariationType.UnknownSales]: 'Vente(s) inconnues(s)',
    [StockVariationType.WarehouseAdditionalDeliveryInRack]: "Livraison additionnelle d'une carte achat",
    [StockVariationType.WarehouseInBox]: "Placé dans une box prête de l'entrepôt",
    [StockVariationType.WarehouseInRack]: "Rangé dans l'entrêpot",
    [StockVariationType.Prepared]: 'Préparé',
    [StockVariationType.WarehouseBundleAborted]: 'Bundle annulé',
};

export const stockVariationTypeIsNegativeVariation: Record<StockVariationType, boolean> = {
    [StockVariationType.Donated]: true,
    [StockVariationType.KnownLossesBroken]: true,
    [StockVariationType.KnownLossesDlc]: true,
    [StockVariationType.KnownSales]: true,
    [StockVariationType.MicrostoreReassort]: false,
    [StockVariationType.MicrostoreWarehouseReturn]: true,
    [StockVariationType.NotDelivered]: true,
    [StockVariationType.NotPrepared]: false,
    [StockVariationType.PreparedProductReset]: false,
    [StockVariationType.Reappearing]: false,
    [StockVariationType.Refund]: false,
    [StockVariationType.StockTransfert]: false,
    [StockVariationType.SupplierRefund]: true,
    [StockVariationType.Transaction]: true,
    [StockVariationType.TrayReassort]: true,
    [StockVariationType.UnknownLosses]: true,
    [StockVariationType.UnknownLossesSolved]: false,
    [StockVariationType.UnknownSales]: false,
    [StockVariationType.UnknownSalesSolved]: true,
    [StockVariationType.WarehouseAdditionalDeliveryInRack]: false,
    [StockVariationType.WarehouseBundleAborted]: false,
    [StockVariationType.WarehouseInBox]: true,
    [StockVariationType.WarehouseInRack]: false,
    [StockVariationType.Prepared]: true,
};

const GENNEVILLIERS_WAREHOUSE_SITE_ID = '4b6e4d6c-6050-4856-80a7-262e6e12112c';
const ASNIERE_WAREHOUSE_SITE_ID = '524e1081-bbb2-4f2a-8746-e965ab9d6ff2';

const GENNEVILLIERS_BROKEN_WAREHOUSE_SITE_ID = '27e14e76-2783-4601-9282-f6936714b10c';
const GENNEVILLIERS_EXPIRED_WAREHOUSE_SITE_ID = '210095ca-9b2f-448d-bff7-17ca8ccb7963';
const ASNIERE_BROKEN_WAREHOUSE_SITE_ID = 'ba7436f4-280d-4a60-9cd2-a4be2de42b81';
const ASNIERE_EXPIRED_WAREHOUSE_SITE_ID = 'd4a42095-b6d1-45ea-b04c-10502e7c6890';

export const FRESH_WAREHOUSE_SITE_ID = ASNIERE_WAREHOUSE_SITE_ID;
export const DRY_WAREHOUSE_SITE_ID = GENNEVILLIERS_WAREHOUSE_SITE_ID;

export const WAREHOUSE_PREP_FLOW: Record<ProductFlow, string> = {
    [ProductFlow.Bakery]: ASNIERE_WAREHOUSE_SITE_ID,
    [ProductFlow.Dry]: GENNEVILLIERS_WAREHOUSE_SITE_ID,
    [ProductFlow.Fresh]: ASNIERE_WAREHOUSE_SITE_ID,
    [ProductFlow.Kumo]: ASNIERE_WAREHOUSE_SITE_ID,
    [ProductFlow.Fruit]: ASNIERE_WAREHOUSE_SITE_ID,
    [ProductFlow.Caterer]: ASNIERE_WAREHOUSE_SITE_ID,
};

// Maps each warehouse site to its stock column.
// Must stay in sync with systems/api/src/constants/warehouse.constants.ts
// and migration 20260421120000-create-default-stock-columns-and-backfill.
export const WAREHOUSE_SITE_TO_COLUMN_ID: Record<string, string> = {
    [ASNIERE_WAREHOUSE_SITE_ID]: '07cbed47-edc3-4599-9efa-020bb4e725b4',
    [GENNEVILLIERS_WAREHOUSE_SITE_ID]: '809e99c8-6ccc-4efd-9692-e45ec531713d',
    [ASNIERE_BROKEN_WAREHOUSE_SITE_ID]: 'def7437f-b503-41bf-bb3f-48538d011c1b',
    [ASNIERE_EXPIRED_WAREHOUSE_SITE_ID]: 'e0cfab7d-0adb-4e6e-9efc-ef14605424a4',
    [GENNEVILLIERS_BROKEN_WAREHOUSE_SITE_ID]: 'a16197dc-bcfb-4dcf-8195-3259a9c8f48c',
    [GENNEVILLIERS_EXPIRED_WAREHOUSE_SITE_ID]: 'f9fe5b55-cc4c-4ba4-8ca6-0b17b2797643',
};
